import { render, staticRenderFns } from "./ManageReportGroupsForm.vue?vue&type=template&id=97f17822&scoped=true"
import script from "./ManageReportGroupsForm.vue?vue&type=script&lang=ts"
export * from "./ManageReportGroupsForm.vue?vue&type=script&lang=ts"
import style0 from "./ManageReportGroupsForm.vue?vue&type=style&index=0&id=97f17822&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f17822",
  null
  
)

export default component.exports